<template>
    <div class="card p-col-12">
        <div class="exception-body notfound card" :style="{ minHeight: 100 + '%' }">
            <img src="assets/layout/images/logo-white.svg" alt="diamond-layout" class="logo" />

            <div class="exception-content">
                <div class="exception-title">Доступ ограничен</div>
                <div class="exception-detail">Ведутся технические работы до 23.07.2024 00:00</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>
